import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Credentials } from './credentials';
import { ErrorStackService } from './error-stack.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {

  credentials: Credentials;

  constructor(private http: HttpClient, 
              private errorStack: ErrorStackService,
              private router: Router) { 
    this.initialize();
  }
  initialize(){
    this.credentials = null;
  }

  login(email, password): Promise<Credentials> {
    const self = this;
    return new Promise((resolve, reject) => {
      self.http.post('https://hsbservices.com/login', {
        "email": email,
        "password": password
      })
      .subscribe((data: any) => {
        if(data && data.user){
            this.credentials = { 
              email:data.user,
              password: null,
              accessToken: data.user.token
            };
            resolve(this.credentials);
        }
      }, error => {
        this.errorStack.append(error, true);
        reject(error);
      });
    });
  }

  logout() {
    this.initialize();
    this.router.navigate(['/login']);
  }

  isLoggedIn() {
    return this.credentials !== null;
  }
  getAccessToken(){
    if(!this.credentials){
      return '';
    }
    return this.credentials.accessToken;
  }

}


    //this.http.get('api.github.com/users/setriosdomain').subscribe(data=>{});
    //this.http.get<MyInterface>('url').subscribe(data=>{});
    //this.http.get('url').subscribe(data=>{},(error: HttpErrorResponse) => {if(error.error instanceof Error){/*client side error*/}else { /*server side error*/}});
    //const req = this.http.post('url', {myPostData: 'data'}).subscribe(res => {}, err => {});


// WEBPACK FOOTER //
// ./src/app/auth.service.ts